// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCw2p5woa-NBb3qdobwwa86vZzIfKBrzJg",
    authDomain: "nycs-surat.firebaseapp.com",
    projectId: "nycs-surat",
    storageBucket: "nycs-surat.firebasestorage.app",
    messagingSenderId: "688219579976",
    appId: "1:688219579976:web:38f6e53d5fe9d4347e1a7d",
    measurementId: "G-SCTFPKTR3Z"
  };
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
export { db, collection, addDoc,auth };
console.log("Firebase App Initialized:", app);
console.log("Firestore Instance:", db);
